import { Pipe, PipeTransform } from '@angular/core';
import * as momentImported from 'moment';
const moment = (momentImported as any).default || momentImported;
@Pipe({
  name: 'miliSecondToMinutes'
})
export class MiliSecondToMinutesPipe implements PipeTransform {
  transform(value: any, args?: any): string {
    // let format = 'mm:ss';
    if (value > 0) {
      let minutes = (value / 60000).toFixed(2);
      return `${minutes} mins`;
    } else {
      return '00:00 mins';
    }

    // return moment.utc().startOf('day').add(value, 'minutes').format(format);
  }

}
